/**
 * Legacy RolesApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.rolesApi`) keep resolving.
 *
 * The actual RolesApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/roles/roles-api.service.ts
 */
angular.module("acme.common.service.rolesApi", [
  "acme.common.factory.QueryStringBuilder",
]);
